/* global Promise */
(function () {
    'use strict';

    angular
        .module('app')
        .controller('ChangePlanController', ChangePlanController);

    ChangePlanController.$inject = ['debug', 'API', 'i18n', '$scope'];

    function ChangePlanController(debug, API, i18n, $scope) {
        var vm = this;
        vm.cancel = $scope.$parent.cancel;
        vm.resolve = $scope.$parent.resolve;
        vm.submit = submit;
        vm.isSubmitting = false;
        vm.subscriptionPlans = [];

        vm.data = {
            group_id: 0
        };

        activate();

        function activate() {
            loadSubscriptionPlans()
                .then(function () {
                    vm.data.group_id = $scope.placeholders.groupId;
                    vm.subscription = $scope.placeholders.subscription;

                    if (vm.subscription) {
                        vm.data.subscription_plan_id = vm.subscription.fk_plan_id;
                    }
                }, function () {
                });
        }

        function loadSubscriptionPlans() {
            return new Promise(function (resolve, reject) {
                API.SubscriptionPlan.getCached()
                    .$promise
                    .then(function (response) {
                        angular.forEach(response.items, function (plan) {
                            if (plan.provider === 'Stripe') {
                                vm.subscriptionPlans.push({
                                    value: plan.id,
                                    label: plan.name,
                                    subLabel: plan.price + ' ' + plan.currency + ' per ' + plan.recurrence_months + ' month(s)',
                                });
                            }
                        });

                        resolve();
                    }, reject);
            });
        }

        function submit() {
            if (!vm.isSubmitting) {
                vm.isSubmitting = true;

                API.Subscription.stripeChangePlan(vm.data)
                    .$promise
                    .then(function (response) {
                        $scope.$parent.submit(response);
                    }, function () {
                    });
            }
        }
    }
})();